<section class="tia-record-summary" *transloco="let t">
  @if (outcomeKey(); as key) {
    <p class="tia-record-summary__outcome">{{ t(key) }}</p>
  }
  <p class="tia-record-summary__note">{{ t('tia.record_summary.no_questionnaire_note') }}</p>

  <dl class="tia-record-summary__grid">
    @if (vendorName(); as vendor) {
      <div class="tia-record-summary__item">
        <dt>{{ t('tia.wizard.field_vendor') }}</dt>
        <dd>{{ vendor }}</dd>
      </div>
    }
    @if (countryName(); as country) {
      <div class="tia-record-summary__item">
        <dt>{{ t('tia.wizard.field_country') }}</dt>
        <dd>{{ country }}</dd>
      </div>
    }
    <div class="tia-record-summary__item">
      <dt>{{ t('tia.record_summary.activity_label') }}</dt>
      <dd>
        @if (!hasActivity()) {
          {{ t('tia.wizard.pa_not_linked') }}
        } @else {
          {{ activityName() || t('tia.record_summary.activity_unresolved') }}
        }
      </dd>
    </div>
    @if (derogationLabelKeys().length > 0) {
      <div class="tia-record-summary__item tia-record-summary__item--wide">
        <dt>{{ t('tia.record_summary.derogations_label') }}</dt>
        <dd>
          <ul class="tia-record-summary__chips">
            @for (key of derogationLabelKeys(); track key) {
              <li>{{ t(key) }}</li>
            }
          </ul>
        </dd>
      </div>
    }
    @if (rationale(); as text) {
      <div class="tia-record-summary__item tia-record-summary__item--wide">
        <dt>{{ t('tia.record_summary.rationale_label') }}</dt>
        <dd class="tia-record-summary__rationale">{{ text }}</dd>
      </div>
    }
    <div class="tia-record-summary__item">
      <dt>{{ t('tia.record_summary.recorded_label') }}</dt>
      <dd>
        {{ assessment().created_at | date: 'mediumDate' }}
        @if (assessment().created_by_name; as by) {
          · {{ by }}
        }
      </dd>
    </div>
    @if (nextReviewAt(); as reviewAt) {
      <div class="tia-record-summary__item">
        <dt>{{ t('tia.record_summary.next_review_label') }}</dt>
        <dd>{{ reviewAt | date: 'mediumDate' }}</dd>
      </div>
    }
  </dl>
</section>
